import { DataManager } from "../model/DataManager.js";
import { VOSpeaker, VOVideo } from "../model/DataStructure.js";
import { Language } from "../model/Language.js";

export class VideoText {
    public element: HTMLDivElement;

    private _video: VOVideo = null;

    private _title: HTMLDivElement;
    private _subtitle: HTMLDivElement;
    private _description: HTMLDivElement;
    private _speakerContent: HTMLDivElement;
    private _speaker: HTMLDivElement;
    private _speakerLabel: HTMLDivElement;
    private _speakerImage: HTMLDivElement;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.className = "video-text scrollbar vert";
        this.element.innerHTML = `
            <div class="video-text-title"></div>
            <div class="video-text-subtitle"></div>
            <div class="video-text-description"></div>
            <div class="video-text-speaker-content">
                <div class="video-text-speaker-label"></div>
                <div class="video-text-speaker"></div>
                <div class="video-text-speaker-image"></div>
            </div>
        `;

        this._title = this.element.querySelector(".video-text-title");
        this._subtitle = this.element.querySelector(".video-text-subtitle");
        this._description = this.element.querySelector(".video-text-description");
        this._speakerContent = this.element.querySelector(".video-text-speaker-content");
        this._speakerImage = this.element.querySelector(".video-text-speaker-image");
        this._speakerLabel = this.element.querySelector(".video-text-speaker-label");
        this._speaker = this.element.querySelector(".video-text-speaker");

        Language.onChange.add((language) => this.update());
    }

    public get video(): VOVideo {
        return this._video;
    }

    public set video(video: VOVideo) {
        if (this._video == video) {
            return;
        }
        this._video = video;

        this.update();
    }

    private update(): void {
        var video = this._video;

        if (!video) {
            //TODO: hide all...
            return;
        }

        this._title.innerHTML = Language.trans(video.title_de, video.title_en);
        this._subtitle.innerHTML = Language.trans(video.subtitle_de, video.subtitle_en);
        this._description.innerHTML = Language.trans(video.description_de, video.description_en);

        var speaker: VOSpeaker = null;
        if (Language.current == "de") {
            speaker = video.speaker_de;
        } else if (Language.current == "en") {
            speaker = video.speaker_en;
        }
        this._speaker.classList.toggle("hidden", !speaker);
        this._speakerImage.classList.toggle("hidden", !speaker);
        this._speakerContent.classList.toggle("hidden", !speaker);
        if (speaker) {

            if (speaker.gender == "male") {
                this._speakerLabel.textContent = Language.translate("main.speaker-male");
            } else {
                this._speakerLabel.textContent = Language.translate("main.speaker-female");
            }
            this._speaker.textContent = speaker.title;
            if (speaker.image) {
                this._speakerImage.style.backgroundImage = `url(${speaker.image.url})`;
            } else {
                this._speakerImage.classList.add("hidden");
            }
        } else {
            this._speakerLabel.textContent = "";
            this._speaker.textContent = "";
        }
    }
}